import React from "react";
import PropTypes from "prop-types";
import { motion } from "framer-motion";

const Button = ({
  className = "",
  children,
  onClick = () => {},
  type = "button",
  disabled = false,
  bgColor = "bg-white",
  textColor = "text-gray-800",
  boxShadowColor = "rgba(255, 255, 255, 0.7)",
}) => {
  return (
    <motion.button
      whileHover={{
        scale: 1.1,
        boxShadow: `0 0 20px 4px ${boxShadowColor}`,
        transition: { duration: 0.3, ease: "easeInOut" },
      }}
      whileTap={{
        scale: 0.95,
        boxShadow: `0 0 15px 3px ${boxShadowColor}`,
        transition: { duration: 0.2, ease: "easeInOut" },
      }}
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`relative uppercase text-center py-3 px-8 rounded-full transition-all duration-200 focus:outline-none focus:ring-0 disabled:opacity-50 disabled:cursor-not-allowed ${bgColor} ${textColor} ${className}`}
    >
      {children}
    </motion.button>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  disabled: PropTypes.bool,
  bgColor: PropTypes.string,
  textColor: PropTypes.string,
  boxShadowColor: PropTypes.string,
};

export default Button;